export const environment = {
	production: false,
	base_href: '/',
	locale: 'en-US',
	currency: {
		symbol: '€',
		label: 'EUR'
	},
	api_url: 'https://tpint.suitairibe.com/',
	// ga_indra: 'UA-133004063-1',
	ga_indra: '',
	ga_tap: '',
	client_book_url: 'https://tap.acc.resfinity.com/',
	pay_api_url: 'https://tpint.suitairibe.com/',
	payment_poc: true,
	paypal_client_id: 'AQWDIlpAuKAg7mgobUV1vs0v2yk8TdYqC7MV_cJPzVlMk1b81mzufBHaz3tRSnL1Oq7U3trN1iRjNkUu',
	cartrawler_api_url: 'https://external-dev-ajax.cartrawler.com',
	cartrawler_client_id: '635394', 
	cartrawler_crosssell_url: 'https://product-router.cartrawler.com', 
	paypal_flow_id: 'TAP_N9DDH7DZXJB5W_VA',
	paypal_code_block_url: 'https://c.paypal.com/da/r/fb.js',
	ip_address_svc_url: 'https://api.ipify.org/?format=json',
  	gtmId: 'GTM-KMD8MNM',
	vwo_url: 'https://dev.visualwebsiteoptimizer.com'
};
